import dayjsImport from "./auth-service-tools36.js";
import { isAfterMinDate } from "./auth-service-tools590.js";
import { isBeforeMaxDate } from "./auth-service-tools591.js";
import { isSameMonth } from "./auth-service-tools587.js";

function getDateInTabOrder(dates, minDate, maxDate, getDateControlProps, excludeDate, hideOutsideDates, month) {
  const enabledDates = dates.flat().filter(date => {
    var _a;

    return isBeforeMaxDate(date, maxDate) && isAfterMinDate(date, minDate) && !(excludeDate == null ? void 0 : excludeDate(date)) && !((_a = getDateControlProps == null ? void 0 : getDateControlProps(date)) == null ? void 0 : _a.disabled) && (!hideOutsideDates || isSameMonth(date, month));
  });
  const selectedDate = enabledDates.find(date => {
    var _a;

    return (_a = getDateControlProps == null ? void 0 : getDateControlProps(date)) == null ? void 0 : _a.selected;
  });

  if (selectedDate) {
    return selectedDate;
  }

  const currentDate = enabledDates.find(date => dayjsImport().isSame(date, "date"));

  if (currentDate) {
    return currentDate;
  }

  return enabledDates[0];
}

export { getDateInTabOrder };